import React, { useState, useEffect } from "react";
import { API_BASE_URL } from "../config";

const costPriceData = [
  { from: 1, to: 200 },
  { from: 201, to: 500 },
  { from: 501, to: 1000 },
  { from: 1001, to: 3000 },
  { from: 3001, to: 5000 },
  { from: 5001, to: 10000 },
  { from: 10001, to: 20000 },
  { from: 20000, to: null },
];

const PriceTable = () => {
  const [markups, setMarkups] = useState({});
  const [user, setUser] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  // Load user data from local storage
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
        fetchExistingMarkups(parsedUser.companyId);
      } catch (e) {
        console.error("Error parsing user data:", e);
      }
    }
  }, []);

  // Fetch existing markup data
  const fetchExistingMarkups = async (companyId) => {
  setLoading(true);
  setError("");
  try {
    const response = await fetch(`${API_BASE_URL}/Order/GetPriceTable?companyId=${companyId}`);
    const result = await response.json();
    console.log("API response:", result);

    // Extract the array safely
    if (response.ok && Array.isArray(result.data)) {
      updateMarkupsState(result.data);
    } else {
      setError("Failed to load markup data. Invalid response.");
    }
  } catch (error) {
    console.error("Fetch error:", error);
    setError("Error fetching existing markup data.");
  } finally {
    setLoading(false);
  }
};
 const updateMarkupsState = (data) => {
  if (!Array.isArray(data)) {
    setError("Unexpected data format from server.");
    return;
  }

  const savedMarkups = {};
  data.forEach((row) => {
    savedMarkups[row.from] = row.markup;
  });

  setMarkups(savedMarkups);
};
 const handleMarkupChange = (from, value) => {
  setMarkups((prev) => ({
    ...prev,
    [from]: value, // keep as string
  }));
  setError("");
};
  const handleMarkupChangeold = (from, value) => {
    setMarkups((prev) => ({
      ...prev,
      [from]: value ? parseFloat(value) : "",
    }));
    setError(""); // Clear error on input change
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    if (!user || !user.companyId) {
      setError("User not found. Please log in again.");
      setLoading(false);
      return;
    }
  
    const validEntries = Object.keys(markups).filter((from) => markups[from] !== "");
  
    if (validEntries.length === 0) {
      setError("Please enter at least one markup value.");
      setLoading(false);
      return;
    }
  
    const requestData = {
      userId: user.userId,
      CompanyId:user.companyId,
      priceTableData: validEntries.map((from) => ({
        from: parseInt(from),
        to: costPriceData.find((row) => row.from == from).to,
        markup: markups[from],
      })),
    };
  
    try {
      const response = await fetch(`${API_BASE_URL}/Order/SavePriceTable`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });
  
      const data = await response.json();
  
      if (response.ok && Array.isArray(data)) {
        alert("Price table data saved successfully!"); 
        updateMarkupsState(data);
        // ✅ Shows an alert message
      } else {
        setError(data.message || "Error saving price data.");
      }
    } catch (error) {
      setError("Error submitting data. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div>
      <form onSubmit={handleSubmit}>
        {error && <p style={{ color: "red" }}>{error}</p>}
        {loading && <p>Submitting...</p>}
        <table border="1" cellPadding="5">
          <thead>
            <tr>
              <th>From</th>
              <th>To</th>
              <th>Markup Multiple (e.g. a cost of $100 ex tax with 3x multiple = $300 including tax)</th>
            </tr>
          </thead>
          <tbody>
            {costPriceData.map((row, index) => (
              <tr key={index}>
                <td>{row.from}</td>
                <td>{row.to ?? "-"}</td>
                <td>
                   <input
  type="text"
  value={markups[row.from] || ""}
  onChange={(e) => {
    let val = e.target.value;

    // Allow empty
    if (val === "") {
      handleMarkupChange(row.from, "");
      return;
    }

    // Allow typing like ".", "1.", "1.2", "1.23"
    if (!/^\d*(\.\d{0,2})?$/.test(val)) return;

    handleMarkupChange(row.from, val);
  }}
  onBlur={(e) => {
    let val = e.target.value;

    // Fix "." → "" or "0.00"
    if (val === ".") {
      handleMarkupChange(row.from, "");
      return;
    }

    // Format to 2 decimal places
    if (val !== "") {
      handleMarkupChange(row.from, parseFloat(val).toFixed(2));
    }
  }}
  style={{ width: "80px" }}
  placeholder="0.00"
/>
  {/* <input
    type="text"
    value={markups[row.from] || ""}
    onChange={(e) => {
      let val = e.target.value;

      // Empty allowed
      if (val === "") {
        handleMarkupChange(row.from, "");
        return;
      }

      // Allow: digits OR digits + dot OR digits + dot + digits
      if (!/^\d*(\.\d*)?$/.test(val)) return;

      // No negative
      if (val.includes("-")) return;

      handleMarkupChange(row.from, val);
    }}
    style={{ width: "80px" }}
    placeholder="0"
  /> */}
</td>



              </tr>
            ))}
          </tbody>
        </table>
        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>

     

      {/* Simple CSS for modal */}
      <style>
        {`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .modal-content {
            background: white;
            padding: 20px;
            border-radius: 8px;
            text-align: center;
          }

          .modal-content button {
            margin-top: 10px;
            padding: 5px 15px;
            background: #007bff;
            color: white;
            border: none;
            cursor: pointer;
            border-radius: 5px;
          }
        `}
      </style>
    </div>
  );
};

export default PriceTable;
